// @ts-check
import React from 'react';
import PropTypes from 'prop-types';
import appEventBus, { API_ADD_STORE_MAPPING_HEADER } from 'config/appEventBus';
import { getStoreMapping } from 'modules/clients/services';

/**
 * Triggers API to pull store mapping
 * Updates the storeNumber based on assignment and adds X-NM-FACILITY header in all requests
 * The Header will added when the toggle is on
 * Should be placed after FeatureTogglesProvider in app hierarchy.
 *
 * @returns {null}
 */
export const StoreMappingLoader = ({ associatePin, selectedStore, isStoreMappingEnabled, setStoreNumber }) => {
  const updateStoreMapping = async (associateId, selectedStore) => {
    if (!associateId) return;
    const mappingData = await getStoreMapping(associateId);

    if (mappingData?.assignedStore) {
      const assignedStore = mappingData.assignedStore.padStart(4, '0');
      appEventBus.emit(API_ADD_STORE_MAPPING_HEADER, assignedStore);

      setStoreNumber({ storeNumber: assignedStore });
    } else {
      appEventBus.emit(API_ADD_STORE_MAPPING_HEADER, selectedStore);
      setStoreNumber({ storeNumber: selectedStore });
    }
  };

  React.useEffect(() => {
    if (isStoreMappingEnabled) {
      updateStoreMapping(associatePin, selectedStore);
    }
  }, []);

  React.useEffect(() => {
    if (isStoreMappingEnabled) {
      appEventBus.emit(API_ADD_STORE_MAPPING_HEADER, selectedStore);
      setStoreNumber({ storeNumber: selectedStore });
    }
  }, [selectedStore]);

  return null;
};

StoreMappingLoader.propTypes = {
  associatePin: PropTypes.string,
  selectedStore: PropTypes.string,
  isStoreMappingEnabled: PropTypes.bool,
  setStoreNumber: PropTypes.func,
};

StoreMappingLoader.defaultProps = {
  associatePin: '',
  isStoreMappingEnabled: false,
  setStoreNumber: () => null,
};

export default StoreMappingLoader;
